import React, {useEffect, useRef, useState} from 'react';
import {CSSTransition} from 'react-transition-group';

import useOnClickOutside from '../../../website-ui/hooks/use-click-outside';

import styles from './index.module.css';

const TIME_OUT = 3000;

const FadeInComponent = ({open, handleExit, className, children}) => {
  const [showComponent, setShowComponent] = useState(false);
  const ref = useRef();

  useOnClickOutside(ref, handleExit);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (handleExit) {
          handleExit();
        }
      }, TIME_OUT);
    }
  }, [open]);

  useEffect(() => {
    setShowComponent(open);
  }, [open]);

  return (
    <CSSTransition
      in={showComponent}
      timeout={500}
      classNames="fade"
      unmountOnExit
      appear
    >
      <div className={className} ref={ref}>
        <div className={styles.container}>
          {children}
        </div>
      </div>
    </CSSTransition>
  );
};

export default FadeInComponent;
